import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'stakeholder.analysis.dashboard',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'stakeholders.by.impact.and.influence',
                        },
                      },
                    },
                    span: 7,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'stakeholders.by.validation.status',
                        },
                      },
                    },
                    span: 5,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'high.priority.table',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 500,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'stakeholders.by.engagement.level',
                        },
                      },
                    },
                    span: 6,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'stakeholders.by.support.level',
                        },
                      },
                    },
                    span: 6,
                  },
                ],
              },
            },
            height: 400,
          },
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'stakeholders.by.understanding',
                        },
                      },
                    },
                    span: 6,
                  },
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'stakeholders.by.sentiment',
                        },
                      },
                    },
                    span: 6,
                  },
                ],
              },
            },
            height: 400,
          },
        ],
      },
    },
    description: 'Dashboard view for stakeholder analysis reporting',
    name: 'Stakeholder Analysis Dashboard',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
